// extracted by mini-css-extract-plugin
export default {"form":"SettingsGeneral_form__h72ya"};